const config = require(`../@${process.env.REACT_APP_TENANT}/config.js`).default;

// locale = e.g. 'de', 'de-CH'
// returns object with the following properties: {
//   group: thousands separator,
//   decimal: decimal separator
// }
export function getNumberFormattingOptions(locale) {
  const formatter = new Intl.NumberFormat(locale, { useGrouping: true });

  // safari hack for not supporting NumberFormat.prototype.formatToParts 😟
  if (!formatter.formatToParts) {
    const formatted = formatter.format(1000.5);
    const [, group, decimal] = formatted.match(
      /([^0-9]?)[0-9]+([^0-9])[0-9]+$/
    );
    return {
      decimal,
      group,
      literal: '',
    };
  }

  let result = {};
  const parts = formatter.formatToParts(1000.5);
  parts
    .filter((p) => p.type !== 'integer' && p.type !== 'fraction')
    .map((p) => {
      result = Object.assign(result, { [p.type]: p.value });
      return p;
    });
  result['literal'] = result['literal'] || '';
  return result;
}

// value = formatted numeric value
export function parseFormattedNumberValue(value, locale) {
  if (typeof value === 'number') return value;
  if (value === '' || value === null || typeof value === 'undefined') return 0;
  let options = getNumberFormattingOptions(locale);
  if (options.group) value = value.replaceAll(options.group, ''); // remove thousands separator
  if (options.decimal && options.decimal !== '.')
    value = value.replace(options.decimal, '.'); // "normalize" decimal symbol to be simple dot
  return parseFloat(value);
}

// currency = currency code, e.g. 'EUR'
// locale = e.g. 'de', 'de-CH'
// returns object with the following properties: {
//   prefix: currency code if the currency and locale specifies currency code to be BEFORE value,
//   suffix: currency code if the currency and locale specifies currency code to be AFTER value,
//   group: thousands separator,
//   decimal: decimal separator
// }
export function getMoneyFormattingOptions(currency, locale) {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    useGrouping: true,
  });

  // Safari hack for not supporting NumberFormat.prototype.formatToParts 😟
  if (!formatter.formatToParts) {
    const numberOptions = getNumberFormattingOptions(locale);
    const formatted = formatter.format(1000.5);
    const numberGroup = `0-9${numberOptions.group}${numberOptions.decimal}`;
    const [, prefix, prefixLiteral, suffixLiteral, suffix] = formatted.match(
      new RegExp(
        `^([^${numberGroup}\\s]*)([\\s]*)[${numberGroup}]+?([\\s]*)([^${numberGroup}\\s]*)$`
      )
    );

    return {
      ...numberOptions,
      currency: prefix || suffix,
      literal: prefixLiteral || suffixLiteral,
      prefix: prefix,
      suffix: suffix,
      fixedDecimalZeroes: config.moneyFieldFixedDecimalZeroes,
    };
  }

  let result = {};
  const parts = formatter.formatToParts(1000.5);
  const currencyIndex = parts.map((p) => p.type).indexOf('currency');

  parts
    .filter((p) => p.type !== 'integer' && p.type !== 'fraction')
    .map((p) => {
      result = Object.assign(result, { [p.type]: p.value });
      return p;
    });

  result['prefix'] = currencyIndex === 0 ? result['currency'] : '';
  result['suffix'] = currencyIndex > 0 ? result['currency'] : '';
  result['literal'] = result['literal'] || '';
  result['fixedDecimalZeroes'] = config.moneyFieldFixedDecimalZeroes;

  return result;
}

// value = formatted money value WITHOUT currency code
export function parseFormattedMoneyValue(value, currency, locale) {
  if (typeof value === 'number') return value;
  if (value === '' || value === null || typeof value === 'undefined') return 0;
  let options = getMoneyFormattingOptions(currency, locale);
  if (options.group) value = value.replaceAll(options.group, ''); //remove thousands separator
  if (options.decimal && options.decimal !== '.')
    value = value.replace(options.decimal, '.'); // "normalize" decimal symbol to be simple dot
  return parseFloat(value);
}

export function toFormattedNumber(value, locale) {
  if (typeof value === 'string') return value;
  if (value === '' || value === null || typeof value === 'undefined') return '';

  const options = getNumberFormattingOptions(locale);
  if (options.decimal && options.decimal !== '.')
    value = value.toString().replace('.', options.decimal);

  return value;
}



// WEBPACK FOOTER //
// ./src/app/helpers/numberFormatting.js